/** versionWatch.ts — 새로 배포되면 열려 있던 화면에 「새 버전」 알림 (2026-11-02 지도사 「보면서 입력하기 없음」)
 *  원인: 화면(SPA)은 한 번 열면 새로고침 전까지 옛 코드로 계속 돈다 — 아침에 연 탭은 낮에 배포한 기능이 안 보인다.
 *  · 처음 불러온 main.*.js 이름을 기억 → 탭으로 돌아올 때 · 10분마다 /asset-manifest.json(no-cache)과 비교
 *  · 바뀌었으면 위쪽 가운데에 작은 알림 「새 버전이 나왔어요 · 새로고침」 — 저절로 새로고침하지 않는다(적던 글이 날아가지 않게)
 *  · 매니페스트를 못 읽는 곳(다른 도메인 안에 넣은 화면 등)은 조용히 넘어간다 */

const EVERY_MS = 10 * 60 * 1000;
const MIN_GAP_MS = 60 * 1000;   // 탭을 자주 오가도 1분에 한 번만 묻는다

const fileOf = (u: string): string => (u.split('?')[0].split('/').pop() || '');

function loadedMain(): string {
  const s = Array.from(document.querySelectorAll('script[src]')).map((e) => (e as HTMLScriptElement).src).find((src) => /\/static\/js\/main\.[^/]+\.js/.test(src));
  return s ? fileOf(s) : '';
}

function showBanner(): void {
  if (document.getElementById('roum-newver')) return;
  const box = document.createElement('div');
  box.id = 'roum-newver';
  box.setAttribute('role', 'status');
  box.style.cssText = 'position:fixed;top:12px;left:16px;right:16px;margin:0 auto;width:fit-content;z-index:2147483000;display:flex;align-items:center;gap:12px;'
    + 'background:#111827;color:#fff;border-radius:10px;padding:8px 8px 8px 16px;font:600 13px/1.4 Pretendard,"Apple SD Gothic Neo",system-ui,sans-serif;'
    + 'box-shadow:0 6px 20px rgba(17,24,39,.18)';
  const msg = document.createElement('span');
  msg.textContent = '새 버전이 나왔어요 — 새로고침하면 바로 반영돼요';
  msg.style.cssText = 'flex:1;min-width:0;word-break:keep-all';
  const go = document.createElement('button');
  go.type = 'button'; go.textContent = '새로고침';
  go.style.cssText = 'height:30px;min-width:84px;border:0;border-radius:7px;background:#fff;color:#111827;font-family:inherit;font-size:12.5px;font-weight:700;cursor:pointer;flex-shrink:0';
  go.onclick = () => window.location.reload();
  const later = document.createElement('button');
  later.type = 'button'; later.textContent = '나중에'; later.title = '닫기 — 다음 배포 때 다시 알려요';
  later.style.cssText = 'height:30px;min-width:64px;border:0;border-radius:7px;background:transparent;color:#D1D5DB;font-family:inherit;font-size:12.5px;font-weight:600;cursor:pointer;flex-shrink:0';
  later.onclick = () => box.remove();
  box.append(msg, go, later);
  document.body.appendChild(box);
}

export function startVersionWatch(): void {
  const mine = loadedMain();
  if (!mine) return;   // 개발 서버 등 — 빌드 파일 이름이 없으면 비교하지 않는다
  let last = 0; let told = '';
  const check = async () => {
    const now = Date.now();
    if (now - last < MIN_GAP_MS) return;
    last = now;
    try {
      const r = await fetch('/asset-manifest.json', { cache: 'no-store' });
      if (!r.ok) return;
      const j = await r.json() as { files?: Record<string, string> };
      const live = fileOf((j.files && j.files['main.js']) || '');
      if (live && live !== mine && live !== told) { told = live; showBanner(); }
    } catch { /* 오프라인 등 — 다음에 */ }
  };
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') void check(); });
  window.addEventListener('focus', () => { void check(); });
  window.setInterval(() => { if (document.visibilityState === 'visible') void check(); }, EVERY_MS);
}
